export default __webpack_public_path__ + "static/media/001-A.ee267a51.svg";